import React from 'react';
import {FaTools} from 'react-icons/fa';
import Translate from "../../../modules/local/Translate";

// ─── Component ─────────────────────────────────────────────────────────────
const UnderDevelopment = ({
                              icon: Icon = FaTools,
                              iconSize = 30,
                              titleKey = 'under_development.title',
                              messageKey = 'under_development.message',
                              className = '',
                          }) => (
    <Translate>
        {(t) => (
            <div className={`mx-3 px-4 h-48 background-200 rounded-3xl flex flex-col flex-center ${className}`}>
                <Icon size={iconSize} className="text-color-500 mb-3"/>
                <span className="text-color-500 font-semibold tracking-wide text-sm mb-1">
                    {t(titleKey)}
                </span>
                <span className="text-color-200 tracking-wider text-sm text-center">
                    {t(messageKey)}
                </span>
            </div>
        )}
    </Translate>
);

export default UnderDevelopment;
